import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth, db } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setCurrentUser(user);
        try {
          // Check admin first
          const adminDoc = await getDoc(doc(db, 'admins', user.uid));
          if (adminDoc.exists()) {
            setUserRole('admin');
            setUserProfile(adminDoc.data());
            setLoading(false);
            return;
          }

          // Check org second
          const orgDoc = await getDoc(
            doc(db, 'organizations', user.uid)
          );
          if (orgDoc.exists()) {
            setUserRole('org');
            setUserProfile(orgDoc.data());
            setLoading(false);
            return;
          }

          // Check donor last
          const donorDoc = await getDoc(doc(db, 'donors', user.uid));
          if (donorDoc.exists()) {
            setUserRole('donor');
            setUserProfile(donorDoc.data());
            setLoading(false);
            return;
          }

          // No role found
          setUserRole(null);
          setUserProfile(null);
        } catch (err) {
          console.error('AuthContext error:', err);
          setUserRole(null);
          setUserProfile(null);
        }
      } else {
        setCurrentUser(null);
        setUserRole(null);
        setUserProfile(null);
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    userRole,
    userProfile,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}